import React from "react";
import { Star, Shield, BadgeCheck, Hammer } from "lucide-react";
import { useLang } from "../context/LanguageContext";

const TrustBadges = () => {
  const { t } = useLang();
  const items = [
    { icon: Star, value: "5.0 / 5", label: t.trust.reviews, color: "text-yellow-500" },
    { icon: Hammer, value: "2.500+", label: "Installaties uitgevoerd", color: "text-brand" },
    { icon: Shield, value: "10 jaar", label: t.trust.warranty, color: "text-brand" },
    { icon: BadgeCheck, value: "100%", label: "Gecertificeerde monteurs", color: "text-brand" },
  ];

  const partners = ["Tesla", "Huawei", "BYD", "Zaptec", "Fronius", "SolarEdge"];

  return (
    <section className="py-14 bg-slate-50/60 border-y border-slate-200/60" data-testid="trust-badges">
      <div className="max-w-7xl mx-auto px-5 lg:px-8">
        <p className="text-center text-sm uppercase tracking-[0.25em] font-bold text-slate-500 mb-9">{t.trust.title}</p>
        <div className="grid grid-cols-2 md:grid-cols-4 gap-5">
          {items.map((it, i) => (
            <div key={i} className="bg-white rounded-2xl border border-slate-200 p-6 text-center hover:border-brand/40 hover:-translate-y-1 transition-all duration-300">
              <it.icon className={`mx-auto mb-3 ${it.color}`} size={28} strokeWidth={2} />
              <div className="font-heading font-black text-3xl text-navy-900">{it.value}</div>
              <div className="text-sm text-slate-500 mt-1">{it.label}</div>
            </div>
          ))}
        </div>

        {/* Partner logos strip */}
        <div className="mt-12 pt-9 border-t border-slate-200/60">
          <p className="text-center text-[11px] uppercase tracking-[0.3em] font-bold text-slate-400 mb-6">
            Officieel partner van premium A-merken
          </p>
          <div className="flex flex-wrap items-center justify-center gap-x-10 gap-y-4">
            {partners.map((p) => (
              <span
                key={p}
                className="font-heading font-black text-xl md:text-2xl text-slate-400 hover:text-navy-900 transition-colors duration-300 tracking-tight"
              >
                {p}
              </span>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default TrustBadges;
